import { onMounted } from 'vue';

const formatTooltipContent = (title: string): string => title.split('\n').join('<br>');

export const useShiftTooltip = () => {
    const setupTooltip = () => {
        const tooltip = document.createElement('div');
        tooltip.className = 'ts-tooltip';
        tooltip.style.cssText = 'position: absolute; display: none; width: auto; min-width: 200px; ' +
            'max-width: 453px; background-color: #1A2021 !important; color: #FFFFFF; padding: 8px 16px; ' +
            'border-radius: 4px; font-family: Roboto, sans-serif; font-weight: 400; font-size: 14px; ' +
            'line-height: 24px; letter-spacing: 0%; vertical-align: middle; ' +
            'box-shadow: 0px 12px 8px -4px #11423E1A; z-index: 10000; pointer-events: none; ' +
            'white-space: pre-line; word-wrap: break-word;';
        document.body.appendChild(tooltip);

        const handleMouseOver = (e: MouseEvent) => {
            const targetElement = e.target as HTMLElement;
            const target = targetElement.closest('.shift-tooltip-icon, .shift-partial-leave-icon') as HTMLElement;
            if (!target) return;
            const title = target.getAttribute('title');
            if (!title) return;
            tooltip.innerHTML = formatTooltipContent(title);
            tooltip.style.display = 'block';
            
            const rect = target.getBoundingClientRect();
            const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
            const scrollY = window.pageYOffset || document.documentElement.scrollTop;
            
            tooltip.style.left = `${rect.left + scrollX + rect.width / 2}px`;
            tooltip.style.top = `${rect.top + scrollY - 8}px`;
            tooltip.style.transform = 'translate(-50%, -100%)';
            target.setAttribute('data-original-title', title);
            target.removeAttribute('title');
        };

        const handleMouseOut = (e: MouseEvent) => {
            const targetElement = e.target as HTMLElement;
            const target = targetElement.closest('.shift-tooltip-icon, .shift-partial-leave-icon') as HTMLElement;
            if (!target) return;
            tooltip.style.display = 'none';
            const originalTitle = target.getAttribute('data-original-title');
            if (originalTitle) target.setAttribute('title', originalTitle);
        };

        document.addEventListener('mouseover', handleMouseOver);
        document.addEventListener('mouseout', handleMouseOut);
    };

    onMounted(() => {
        setupTooltip();
    });
};
